import React from 'react';
import { TypedMemo } from '../../../common/types';
import { AddAssetDialog } from './AddAssetDialog';
import { useAddAssetRequest } from './addAssetDialogStore';

/** Draws the "Add …" dialog of "Add yours" for the whole app (mounted once in `SMLContainer`). */
const AddAssetHostComponent: React.FC = () => {
  const request = useAddAssetRequest();
  return <AddAssetDialog request={request} />;
};

export const AddAssetHost = TypedMemo(AddAssetHostComponent);
